import { V_URL_API } from "../../../../../../../../../utils/config";


/**
 * Servicio para obtener el detalle de un curso.
 *
 * @param {number} curso_id - ID del curso a consultar.
 * @returns {Promise<Response>} - Respuesta de la API con la información del detalle del curso.
 * @throws {Error} - Lanza un error si la petición falla.
 */
export async function getDetalleCurso(vToken,curso_id) {
  const myHeaders = new Headers();
  myHeaders.append("Authorization", `E ${vToken}`);
  myHeaders.append("Content-Type", "application/json");
  const requestOptions = {
    method: "GET",
    redirect: "follow",
    headers: myHeaders
  };

  // Construcción de la URL para el endpoint de detalle de curso
  const url = `${V_URL_API}/api/perfil_general/detalle_curso/${curso_id}`;
  return await fetch(url, requestOptions);
}
